/* eslint-disable */
import $ from "jquery";
import Vue from "vue";

//import Articles from "./components/Articles.vue";
//import Posts from "./components/Posts.vue";
//import Projects from "./components/Projects.vue";
import lozad from "lozad";

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function() {
  log.history = log.history || []; // store logs to an array for reference
  log.history.push(arguments);
  if (this.console) {
    window.console.log(Array.prototype.slice.call(arguments));
  }
};

/*
new Vue({
  el: "#app",
  components: { Articles, Posts, Projects }
});
*/

window.jQuery = window.$ = require("jquery");

//const observer = lozad();
//observer.observe();

let jQuery = $;

//Toggle bulma mobile nav classes on click
$(document).ready(function() {
  $(".navbar-burger").click(function() {
    $(".navbar-burger").toggleClass("is-active");
    $(".navbar-menu").toggleClass("is-active");
  });
});


var mobileIcon = document.getElementById('nav-mobile__hamburger');
var menuMobile = document.getElementById('nav-mobile');
var header = document.getElementById('header');
var footer = document.getElementById('footer');
var mainContent = document.getElementById('main-content');
var mobileLogoContainer = document.getElementById('navigation__mobile');

mobileIcon.onclick = function() {
  mobileIcon.classList.toggle('open');
  mobileLogoContainer.classList.toggle('open');
  console.log('click nav');
  if(mobileIcon.classList.contains('open')) {
    console.log('click nav 1');
    openedNav();
  } else {
    console.log('click nav 0');
    closedNav();
  }
}

function openedNav() {
  menuMobile.classList.add('open');
    menuMobile.style.display = 'block';
    header.style.display = 'none';
    footer.style.display = 'none';
    mainContent.style.display = 'none';
}

function closedNav() {
  menuMobile.classList.remove('open');
    menuMobile.style.display = 'none';
    header.style.display = 'block';
    footer.style.display = 'block';
    mainContent.style.display = 'block';
}



// WEBPACK FOOTER //
// ./resources/assets/js/main.js


// WEBPACK FOOTER //
// webpack:///./resources/assets/js/main.js


// WEBPACK FOOTER //
// webpack:///webpack:///./resources/assets/js/main.js


// WEBPACK FOOTER //
// webpack:///webpack:///webpack:///./resources/assets/js/main.js